import '../vendor';

import '../general/ofi';
import '../general/anchor';
import '../general/menu.js';
import '../general/find';
import '../general/search-clear';
import '../general/aside-filter';

import './one-theme/all-exponats';
import './one-theme/clips';
import './one-theme/authors';


// WEBPACK FOOTER //
// ./src/js/pages/one-theme.js